// Pathless layout route. Every authenticated route file is named
// `_authed.<segment>.tsx` and renders inside this layout's <Outlet/>.
//
// AuthGate (mounted in __root) gates everything; this layout's only job is
// to mount the operator Shell (Header / NavRail / TimeScrubber / CommandLine /
// AuditTicker) once for every authenticated leaf. That eliminates the
// public-vs-protected predicate juggling that used to live in __root.

import { FirstLoginFocusModal } from '@/components/onboarding/FirstLoginFocusModal';
import { Shell } from '@/shell/Shell';
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed')({
  component: AuthedLayout,
});

function AuthedLayout() {
  return (
    <Shell>
      <Outlet />
      {/* First-login Focus modal opens when /v1/me reports focus === null.
          Self-gates internally; renders nothing for tenants whose focus is
          configured. Per the Phase D plan: replaces the apologetic empty
          AI-rail state with an onboarding moment. */}
      <FirstLoginFocusModal />
    </Shell>
  );
}
